<template>
  <AppDialog title="Buscar módulo" focusFirst @close="hidden">
    <div class="relative w-full">
      <!-- Modal content -->
      <div class="relative rounded-lg">
        <!-- Modal header -->
        <div class="pb-4 border-b rounded-t">
          <div class="relative w-full">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <font-awesome-icon icon="fa-solid fa-search" class="w-5 h-5 text-gray-500" />
            </div>
            <input type="text"
              class="bg-white border-2 border-slate-200 text-slate-800 text-sm rounded-lg focus:border-blue-500 block w-full pl-10 p-2.5 outline-none"
              aria-label="Nombre del módulo" placeholder="Buscar..." autocomplete="off" v-model="searchTerm" @input="handleSearch" ref="searchInput" />
          </div>
        </div>
        <!-- Modal body -->
        <div class="pt-4">
          <div>
            <router-link v-for="(data, i) in filteredResults" :to="data.url"
              class="min-h-[44px] py-3 mb-2 bg-slate-50 rounded-md px-3 text-slate-700 hover:bg-blue-50 flex items-center justify-between hover:text-blue-700"
              :key="i" @click="handleKeyDownClick">
              {{ data.descripcion }}
              <svg class="w-2 h-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 9 4-4-4-4" />
              </svg>
            </router-link>
          </div>
          <p v-if="filteredResults.length === 0" class="text-sm font-normal text-orange-500 dark:text-gray-400">
            No se encontraron resultados.
          </p>
        </div>
      </div>
    </div>
  </AppDialog>
</template>

<script>
import { onMounted, onUnmounted, ref } from "vue";
import AppDialog from '@/components/PublicComponents/AppDialog.vue';
import {
  hydrateModulesState,
  MODULES_UPDATED_EVENT,
  modulesState,
} from "@/utils/accessModules";

export default {
  name: "SearchMenus",
  components: { AppDialog },
  emits: ["send-data"],
  props: {
    hidden: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const modules = ref([]);
    const filteredResults = ref([]);
    const searchTerm = ref('');
    const searchInput = ref(null);

    const syncModules = (nextModules = modulesState.value) => {
      modules.value = Array.isArray(nextModules) ? nextModules : [];
      handleSearch();
    };

    const searchableSubmodules = (modulo) => {
      const submodules = Array.isArray(modulo?.submodulos)
        ? modulo.submodulos
        : [];
      const hasDgiiContainer = submodules.some(
        (submodulo) => submodulo?.url === "/reporte-para-dgii"
      );

      if (hasDgiiContainer) {
        return submodules.filter(
          (submodulo) => submodulo?.url !== "/reporte-dgii-606"
        );
      }

      return submodules.map((submodulo) =>
        submodulo?.url === "/reporte-dgii-606"
          ? {
              ...submodulo,
              descripcion: "Reporte para DGII",
            }
          : submodulo
      );
    };

    // Función para manejar el evento de búsqueda
    const handleSearch = () => {
      filteredResults.value = [];

      modules.value.forEach((modulo) => {
        const matchingSubmodulos = searchableSubmodules(modulo).filter((submodulo) => {
          return submodulo.descripcion
            .toLowerCase()
            .includes(searchTerm.value.toLowerCase());
        });

        filteredResults.value.push(...matchingSubmodulos);
      });
    };

    /*******************************************************************************************
     * Funcion para cambiar de estado de tipo de busqueda con combinacion de teclas ALT+N
     *******************************************************************************************/
    const handleKeyDown = async (event) => {
      if (event.keyCode === 27) {
        props.hidden();
      }
    };
    const handleKeyDownClick = async () => {
      props.hidden();
    };

    const handleModulesUpdated = (event) => {
      syncModules(event?.detail?.modules || []);
    };

    onMounted(() => {
      hydrateModulesState();
      syncModules(modulesState.value);
      window.addEventListener("keydown", handleKeyDown);
      window.addEventListener(MODULES_UPDATED_EVENT, handleModulesUpdated);
      searchInput.value.focus();
    });

    onUnmounted(() => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener(MODULES_UPDATED_EVENT, handleModulesUpdated);
    });

    return {
      handleSearch,
      filteredResults,
      searchTerm,
      handleKeyDownClick,
      searchInput
    };
  },
};
</script>
